export class Activity {
  creationTime?: Date | string;
  creatonTime?: Date | string;
  updatedAt?: string;
  name?: string;
  amount: number | string;
  coin: number | string;
  destCoin?: number;
  status: number;
  srcCoin?: number;
  userId: string;
  type: number;
  subtype?: number;
  withdrawType?: WITHDRAW_TYPE;
  _id: string;
  isBenefit?: boolean;
  category: string;
  payment?: boolean;

  constructor() {}
}

export enum ACTIVITY_TYPE {
  ORDER,
  WITHDRAWAL,
  DEPOSIT,
  TIME_DEPOSIT,
  CRYPTO_TRANSACTION,
  CRYPTO_STAKING,
}
export enum WITHDRAW_TYPE {
  SOLIDARY = 0,
  INFINITE = 1,
}
